import { useEffect, useRef } from 'react';
import { queueMacrotask } from 'utils/macrotask';

export const useTextSelection = (
  elRef: React.RefObject<HTMLDivElement>,
  handleSelection: () => void,
): void => {
  type Fn = (e: Event) => void;
  const savedHandler = useRef<Fn>(() => null);

  useEffect(() => {
    savedHandler.current = handleSelection;
  }, [handleSelection]);

  useEffect(() => {
    const eventListener = (event) => savedHandler.current(event);

    // Check for selection only when there's an arrow key event.
    enum ArrowKeys {
      Left = 37,
      Up = 38,
      Right = 39,
      Down = 40,
    }
    const handleKeyboardSelection = (e: KeyboardEvent) => {
      if (Object.values(ArrowKeys).includes(e.keyCode)) {
        queueMacrotask(eventListener);
      }
    };
    const documentEl = elRef.current;

    documentEl?.addEventListener('mouseup', eventListener);
    documentEl?.addEventListener('dblclick', eventListener);
    documentEl?.addEventListener('keydown', handleKeyboardSelection);

    return () => {
      documentEl?.removeEventListener('mouseup', eventListener);
      documentEl?.removeEventListener('dblclick', eventListener);
      documentEl?.removeEventListener('keydown', handleKeyboardSelection);
    };
  }, [elRef]);
};
